export type DiscountBand = {
  min: number;
  max: number;
  rep: number;
  firstYear: number;
  quarterly: number;
  semi: number;
  twoyd_annual: number;
  twoyd_upfront: number;
  threeyd_annual: number;
  threeyd_upfront: number;
  assistant: number;
  enterprise: number;
  byoc: number;
  monthlyMin: number;
  db_max: number;
  asst_max: number;
  byoc_max: number;
};

export const discountTable: DiscountBand[] = [
  {
    min: 8000,
    max: 29999,
    rep: 0.06,
    firstYear: 0.03,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.02,
    twoyd_upfront: 0.03,
    threeyd_annual: 0.03,
    threeyd_upfront: 0.04,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.14,
    asst_max: 0.21,
    byoc_max: 0.28,
  },
  {
    min: 30000,
    max: 39999,
    rep: 0.07,
    firstYear: 0.03,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.02,
    twoyd_upfront: 0.03,
    threeyd_annual: 0.03,
    threeyd_upfront: 0.04,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.15,
    asst_max: 0.22,
    byoc_max: 0.29,
  },
  {
    min: 40000,
    max: 49999,
    rep: 0.08,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.02,
    twoyd_upfront: 0.04,
    threeyd_annual: 0.04,
    threeyd_upfront: 0.04,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.17,
    asst_max: 0.24,
    byoc_max: 0.31,
  },
  {
    min: 50000,
    max: 59999,
    rep: 0.09,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.02,
    twoyd_upfront: 0.04,
    threeyd_annual: 0.04,
    threeyd_upfront: 0.04,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.18,
    asst_max: 0.25,
    byoc_max: 0.32,
  },
  {
    min: 60000,
    max: 79999,
    rep: 0.1,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.04,
    threeyd_annual: 0.04,
    threeyd_upfront: 0.04,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.19,
    asst_max: 0.26,
    byoc_max: 0.33,
  },
  {
    min: 80000,
    max: 99999,
    rep: 0.11,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.05,
    threeyd_annual: 0.05,
    threeyd_upfront: 0.05,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.2,
    asst_max: 0.27,
    byoc_max: 0.34,
  },
  {
    min: 100000,
    max: 149999,
    rep: 0.12,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.05,
    threeyd_annual: 0.05,
    threeyd_upfront: 0.05,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.21,
    asst_max: 0.28,
    byoc_max: 0.35,
  },
  {
    min: 150000,
    max: 199999,
    rep: 0.13,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.06,
    threeyd_annual: 0.06,
    threeyd_upfront: 0.06,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.22,
    asst_max: 0.29,
    byoc_max: 0.36,
  },
  {
    min: 200000,
    max: 249999,
    rep: 0.14,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.06,
    threeyd_annual: 0.06,
    threeyd_upfront: 0.06,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.23,
    asst_max: 0.3,
    byoc_max: 0.37,
  },
  {
    min: 250000,
    max: 299999,
    rep: 0.15,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.06,
    threeyd_annual: 0.06,
    threeyd_upfront: 0.06,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.24,
    asst_max: 0.31,
    byoc_max: 0.38,
  },
  {
    min: 300000,
    max: 399999,
    rep: 0.17,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.06,
    threeyd_annual: 0.06,
    threeyd_upfront: 0.06,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.26,
    asst_max: 0.33,
    byoc_max: 0.4,
  },
  {
    min: 400000,
    max: 499999,
    rep: 0.19,
    firstYear: 0.04,
    quarterly: -0.05,
    semi: -0.03,
    twoyd_annual: 0.03,
    twoyd_upfront: 0.06,
    threeyd_annual: 0.06,
    threeyd_upfront: 0.06,
    assistant: 0.07,
    enterprise: 0.04,
    byoc: 0.2,
    monthlyMin: 0.04,
    db_max: 0.28,
    asst_max: 0.35,
    byoc_max: 0.42,
  },
];

export function findDiscountBand(acv: number): DiscountBand | null {
  for (const band of discountTable) {
    if (acv >= band.min && acv < band.max + 1) {
      return band;
    }
  }
  return null;
}
